import axios from 'axios';

export default axios.create({
  baseURL: import.meta.env.VITE_API_URL || "/api",
  headers: {
    "Content-type": "application/json",
  },
});
